export default class BillingSummary {
    constructor() {
      this.day1Hours = null;
      this.day2Hours = null;
      this.day3Hours = null;
      this.day4Hours = null;
      this.day5Hours = null;
      this.day6Hours = null;
      this.day7Hours = null;
      this.day8Hours = null;
      this.day9Hours = null;
      this.day10Hours = null;
      this.day11Hours = null;
      this.day12Hours = null;
      this.day13Hours = null;
      this.day14Hours = null;
      this.day15Hours = null;
      this.day16Hours = null;
    }
    tmIds?: Array<number | null> | null;
    clientNumber?: number | null;
    prospectNumber?: number | null;
    sectionNumber?: number | null;
    unitNumber?: number | null;
    clientName?: string;
    prospectName?: string;
    sectionName?: string;
    unitName?: string;
    workClassificationName?: string;
    day1Hours?: number | null;
    day2Hours?: number | null;
    day3Hours?: number | null;
    day4Hours?: number | null;
    day5Hours?: number | null;
    day6Hours?: number | null;
    day7Hours?: number | null;
    day8Hours?: number | null;
    day9Hours?: number | null;
    day10Hours?: number | null;
    day11Hours?: number | null;
    day12Hours?: number | null;
    day13Hours?: number | null;
    day14Hours?: number | null;
    day15Hours?: number | null;
    day16Hours?: number | null;
  
    totalHours?: number | null;
}


// WEBPACK FOOTER //
// ./src/models/AP/BillingSummary.ts